/**
 * 引入用到了的 Bootstrap Component
 */
import 'bootstrap/js/dist/button'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/carousel'
import Tooltip from 'bootstrap/js/dist/tooltip'


/**
 * 初始化 Tooltip
 */
function initTooltips() {
  document.querySelectorAll<HTMLElement>('[data-bs-toggle="tooltip"]').forEach(element => {
    /*
    适配 Bootstrap Tooltip 和 Percel 的打包模式
    -------------------------
    Bootstrap Tooltip 的 title 内容是要写在 attribute 而不是外置的 HTML 里的，
    如果 title 中有 HTML 内容，且引用了本地图片，Parcel 就不会识别到，也就引用不成功。

    因此这里改为把图片内容写到实际的 HTML 里，让 Parcel 能够识别，然后再把 HTML 写入到 title attribute
    */
    if (element.dataset.titleElementId) {
      const template = document.getElementById(element.dataset.titleElementId)
      if (template) {
        element.title = template.innerHTML
        template.parentElement?.removeChild(template)
      }
    }

    new Tooltip(element)
  })
}


/**
 * 执行初始化
 */
window.addEventListener('DOMContentLoaded', () => {
  initTooltips()
})
